import styled from 'styled-components';
import { transparentize } from 'polished';
import { colors } from '@keen.io/colors';
export var Separator = styled.span.withConfig({
  displayName: "AbsoluteTimeLabelstyles__Separator",
  componentId: "keen-query-creator__sc-11ga65l-0"
})(["&&&{padding:0 3px;color:", ";}"], transparentize(0.4, colors.blue[500]));
export var Hours = styled.span.withConfig({
  displayName: "AbsoluteTimeLabelstyles__Hours",
  componentId: "keen-query-creator__sc-11ga65l-1"
})(["&&&{color:", ";margin-left:3px;}"], colors.black[100]);